import {rootState} from '@mintdata-wsp/common/state/RootState';
import {VisualArtifact} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/VisualArtifact';
import {VisualComponent} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/VisualComponent';
import {
    VisualComponentsSection,
    VisualComponentsSectionName
} from '@mintdata-wsp/common/state/ui/visualDesigner/SurfaceEditorState';
import {
    FocusedArea,
    VisualDesignerTab,
    WorkbenchState
} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/WorkbenchState';
import {NameUtil} from '@mintdata-wsp/common/util/NameUtil';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import bind from 'bind-decorator';
import {action} from 'mobx';

export class WorkbenchController
{
    @action.bound
    public setFocusedArea(value:FocusedArea):void
    {
        const state = this._getState();

        state.focusedArea = value;
    }

    @action.bound
    public switchToTab(toTab:VisualDesignerTab):void
    {
        const state = this._getState();
        const curTab = state.selectedTab;
        if( curTab && curTab.isEqual(toTab) )
            return;

        state.selectedTab = toTab;

        const perspectives = controllers.ui.perspective;
        perspectives.switchTo(toTab.value());

        if( VisualDesignerTab.SurfaceTab.isEqual(toTab) )
            this._cleanupFlowTabOnSwitch();
        else
            this._cleanupSurfaceTabOnSwitch();

        let openDesign = controllers.ui.openDesign.getOpenDesign();
        if( openDesign )
        {
            let projectId = openDesign.designRef.projectId;
            let designId = openDesign.designRef.designId;
            controllers.navigation.toDesign(projectId, designId);
        }
    }

    public closeAllContextMenus():void
    {
        controllers.ui.flowCanvas.closeBlockContextMenu();
        controllers.ui.flowCanvas.closeWireContextMenu();
    }

    private _cleanupSurfaceTabOnSwitch():void
    {
        this.closeAllContextMenus();
        controllers.ui.surfaceSelection.clearSelectedBoxes();
    }

    private _cleanupFlowTabOnSwitch():void
    {
        this.closeAllContextMenus();
        controllers.ui.flowSelection.clearSelectedBlocks();
    }

    public getSelectedTab():VisualDesignerTab
    {
        return this._getState().selectedTab;
    }

    public getFocusedArea():FocusedArea
    {
        const state = this._getState();

        return state.focusedArea;
    }

    private _getState():WorkbenchState
    {
        let workbench = rootState.ui.visualDesigner.workbench;
        return workbench;
    }

    @action.bound
    public setVisibleVisualComponents(visualComponents:VisualComponent[]):void
    {
        const componentsPanel = rootState.ui.visualDesigner.surfaceEditor.componentsPanel;
        componentsPanel.visibleComponents = visualComponents;
    }

    public getVisibleVisualComponents():VisualComponent[]
    {
        const componentsPanel = rootState.ui.visualDesigner.surfaceEditor.componentsPanel;
        return componentsPanel.visibleComponents;
    }

    public getVisibleVisualComponentsSections():Map<VisualComponentsSectionName, VisualComponentsSection>
    {
        const componentsPanel = rootState.ui.visualDesigner.surfaceEditor.componentsPanel;
        return componentsPanel.visibleComponentsSections;
    }

    @action.bound
    public setFilterString(filterString:string | null):void
    {
        const componentsPanel = rootState.ui.visualDesigner.surfaceEditor.componentsPanel;
        componentsPanel.filterString = filterString;

        this.filterVisibleVisualComponents(filterString);
    }

    public getFilterString():string
    {
        const componentsPanel = rootState.ui.visualDesigner.surfaceEditor.componentsPanel;
        return componentsPanel.filterString;
    }

    @bind
    public filterVisibleVisualComponents(searchString:string | null):void
    {
        const visualArtifacts = controllers.ui.artifacts.getVisualArtifacts();

        if( !visualArtifacts )
            return;

        const visibleComponents:VisualComponent[] = [];
        visualArtifacts.map((va:VisualArtifact) =>
        {
            va.visualComponents.map((vc:VisualComponent) =>
            {
                if( searchString )
                {
                    let displayName = NameUtil.getDisplayName(vc);
                    if( displayName.toLowerCase().indexOf(searchString.toLowerCase()) !== -1 )
                        visibleComponents.push(vc);
                }
                else
                    visibleComponents.push(vc);
            });
        });

        controllers.ui.workbench.setVisibleVisualComponents(visibleComponents);
    }

    @bind
    public getVisualComponentById(componentId:string):VisualComponent
    {
        const visualArtifacts = controllers.ui.artifacts.getVisualArtifacts();

        if( !visualArtifacts )
            return;

        let found:VisualComponent = null;
        visualArtifacts.map((va:VisualArtifact) =>
        {
            va.visualComponents.map((vc:VisualComponent) =>
            {
                //todo: this breaks encapsulation, but what is the better way to find-by-id?
                if( vc.ref.componentId === componentId )
                {
                    found = vc;
                }
            });
        });

        return found;
    }
}
